<template>
    <div class="wrap-video-info">
        <div class="video-play-banner">
            <div class="video-play inner">
                <!--<video-->
                        <!--:id="'my-player'+info.id"-->
                        <!--class="video-js"-->
                        <!--controls-->
                        <!--preload="auto"-->
                        <!--:poster="info.picture"-->
                        <!--data-setup='{}'>-->
                    <!--<source :src="info.video" />-->
                <!--</video>-->
                <video id="myVideo" class="video-js" :src="info.video" type="video/mp4" :poster="info.picture" controls></video>
            </div>
            <div class="play-info inner">
                <h3 class="title">{{info.title}}</h3>
                <p class="desc">{{info.description}}</p>
                <p class="time">{{info.writer}} &nbsp;&nbsp;{{info.create_time}} <span class="hot">{{info.hot}}</span></p>
            </div>
        </div>
        <div class="video-list inner">
            <div class="old-video">
                <h3 class="old-title">最新视频</h3>
                <div class="item" v-for="(item,i) in newsVideoList.slice(0,9)">
                    <router-link :to="'/videocontent/'+item.id" class="item">
                        <div class="cover">
                            <img :src="item.picture" />
                        </div>
                        <div class="item-info">
                            <p class="title">{{item.title}}</p>
                            <p class="time">{{item.create_time}}</p>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="recommand-video">
                <h3 class="title">推荐专访<router-link to="/video">查看更多>></router-link></h3>
                <ul class="list">
                    <li v-for="(item,i) in videoList.slice(0,6)">
                        <router-link :to="'/videocontent/'+item.id">
                            <div class="cover">
                                <img :src="item.picture" />
                            </div>
                            <div class="desc">{{item.title}}</div>
                            <span class="views">{{item.hot}}<i class="icon" v-show="i<3"></i></span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                info: [],
                videoList:[],
                newsVideoList:[]
            }
        },
        methods: {
            requestData() {
                var id = this.$route.params.id;
                var api = 'https://api.yopoo.cn/api/v1/minutenew?id=' + id;
                this.$http.get(api).then((response) => {
                        this.info = response.body.data
                    },
                    err => {
                        console.log(err)
                    }
                )
            },
            initVideo() {
                //初始化视频方法
                // console.log(this.info)
                this.$video('myVideo'+info.id, {
                    //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                    controls: true,
                    poster:this.info.picture || 'http://image.yopoo.cn/uploads/image/20190419/a6cddbbc2c070e9bb22674adb41a3cb7.jpeg'
                });
            }
        },
        watch: {
            '$route': 'requestData'
        },
        // watch: {
        //     '$route' (to, from) { //监听路由是否变化
        //         if(this.$route.params.id){//判断id是否有值
        //             var id=this.$route.params.id;
        //             this.requestData(id);
        //         }
        //     }
        // },
        metaInfo() {
            return {
                title: this.info.title || '',
                meta: [{
                    name: 'keywords',
                    content: this.info.keywords || ''
                },
                    {
                        name: 'description',
                        content: this.info.description || ''
                    }
                ]
            }
        },
        mounted() {
            this.initVideo();
        },
        created() {
            this.requestData();
            this.$http.get('https://api.yopoo.cn/api/v1/recommend?id=1').then((res) => {
                this.videoList = res.body.data || []
            }, (err) => {
                console.log(err)
            })
            this.$http.get('https://api.yopoo.cn/api/v1/recommend?id=1&&sort=create_time').then((res) => {
                this.newsVideoList = res.body.data || []
            }, (err) => {
                console.log(err)
            })
        }
    }
</script>
<style lang="less" rel="stylesheet">
    .inner{
        width: 1200px;
        display: block;
        margin: 0 auto;
    }
    button{
        outline: 0;
    }
    .wrap-video-info {
        .video-play-banner{
            height: 850px;
            background: url("../assets/images/shipin-bg.png") no-repeat center center;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 40px 0;
            .video-play{
                .myVideo-dimensions {
                    width: 100%;
                    height: 660px;
                }
            }
            .play-info{
                .title{
                    font-size: 28px;
                    padding: 20px 0 10px 0;
                    color: #fff;
                }
                .desc{
                    font-size: 18px;
                    color: #fff;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    padding-bottom: 10px;
                }
                .time{
                    color: #D9D9D9;
                    font-size: 14px;
                    .hot{
                        margin-left: 100px;
                        position: relative;
                        padding-left: 16px;
                        &:after{
                            content: "";
                            display: inline-block;
                            position: absolute;
                            background: url("../assets/images/hot-icon2.png") no-repeat center center;
                            background-size: auto 100%;
                            width: 12px;
                            height: 16px;
                            top: 0;
                            left: 0;
                        }
                    }
                }
            }
        }
        .vjs-paused .vjs-big-play-button,
        .vjs-paused.vjs-has-started .vjs-big-play-button {
            display: block;
        }
        .video-js {
            width: 100%;
            height: 660px;
            outline: none;
            object-fit: fill;
            .vjs-poster{
                background-size: 100% 100%;
            }
            .vjs-big-play-button{
                width: 90px;
                height: 50px;
                top: 50%;
                left: 50%;
                margin-top: -25px;
                margin-left: -45px;
                outline: none;
            }
        }
        .video-list{
            display: flex;
            margin: 40px auto;
            .recommand-video{
                width: 320px;
                padding: 20px;
                background: #f8f8f8;
                box-sizing: border-box;
                height: 696px;
                margin-top: 70px;
                .title{
                    font-size: 20px;
                    color: #333;
                    position: relative;
                    padding-left: 10px;
                    height: 20px;
                    line-height: 20px;
                    a{
                        font-size: 14px;
                        color: #333;
                        float: right;
                        font-weight: normal;
                    }
                    &:after{
                        content: "";
                        position: absolute;
                        top: 0;
                        left: 0;
                        display: inline-block;
                        width: 4px;
                        height: 20px;
                        background: #FF0000;
                    }
                }
                .list{
                    li{
                        &:hover{
                            a{
                                background: #f8f8f8;
                                .desc{
                                    color: #7E0007;
                                }
                            }

                        }
                        a{
                            display: flex;
                            padding: 10px 0;
                            border-bottom: 1px solid #E4E4E4;
                            line-height: 40px;
                            color: #333;
                            font-size: 14px;
                            position: relative;
                            .cover{
                                width: 114px;
                                height: 86px;
                                background: #fff;
                                overflow: hidden;
                                display: flex;
                                justify-content: center;
                                img{
                                    height: 100%;
                                }
                            }
                            .desc{
                                margin-left: 10px;
                                flex: 1;
                                overflow: hidden;
                                text-overflow:ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                line-height: 26px;
                                height: 52px;
                            }
                            .views{
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                width: 60px;
                                display: inline-block;
                                i{
                                    display: inline-block;
                                    width: 12px;
                                    height: 12px;
                                    background: url("../assets/images/fire.png") no-repeat center center;
                                    background-size: auto 100%;
                                    vertical-align: baseline;
                                }
                            }
                        }

                    }
                }

            }
            .old-video{
                flex: 1;
                .old-title{
                    font-size: 28px;
                    color: #333;
                    padding-bottom: 30px;
                }
                .item{
                    display: inline-block;
                    width: 274px;
                    height: 212px;
                    background: #f8f8f8;
                    margin-right: 19px;
                    margin-bottom: 30px;
                    .cover{
                        height: 154px;
                        overflow: hidden;
                        img{
                            width: 100%;
                        }
                    }
                    .item-info{
                        padding: 0 10px;
                        box-sizing: border-box;
                        .title{
                            font-size: 16px;
                            color: #333;
                            height: 32px;
                            line-height: 32px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .time{
                            font-size: 14px;
                            color: #999;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/VideoContent.vue